"use client";

import React, { createContext, useContext, ReactNode } from "react";
import { AuthSessionData } from "@cartz/auth";
import type { ShopSummary } from "@/types/shop";
import { initClientShopId } from "@/lib/client-shop";

export interface SessionContextType {
  isAdmin: boolean;
  canSwitchShop: boolean;
  activeShopId: number;
  activeOrganizationId: string;
  authSessionData: AuthSessionData;
  shop?: ShopSummary;
}

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export const useSessionContext = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error(
      "useSessionContext must be used within a SessionContextProvider",
    );
  }
  return context;
};

export const useActiveShop = () => {
  const { shop } = useSessionContext();
  if (!shop) {
    throw new Error("useActiveShop must be used within ShopProvider");
  }
  return shop;
};

interface SessionContextProviderProps {
  children: ReactNode;
  state: SessionContextType;
}

export const SessionContextProvider = ({
  children,
  state,
}: SessionContextProviderProps) => {
  initClientShopId(state.activeShopId);

  return (
    <SessionContext.Provider value={state}>{children}</SessionContext.Provider>
  );
};
